import React from 'react'

import { srpHostedIcon } from './SrpHostedIcon'

type TimeOfDayIcon = { outline: React.FC; filled: React.FC }

/** Outline + `_dark` filled variant (selected state) of the same hosted icon. */
const timeOfDayIcon = (name: string): TimeOfDayIcon => ({
  outline: srpHostedIcon(`${name}.svg`),
  filled: srpHostedIcon(`${name}_dark.svg`),
})

/** Keyed by the `DEPARTURE_TIME_MAPPING_OBJ` slot. */
export const TIME_OF_DAY_ICON: Record<string, TimeOfDayIcon> = {
  '0000': timeOfDayIcon('sunny'),
  '0800': timeOfDayIcon('sunny_snowing'),
  '1200': timeOfDayIcon('clear_day'),
  '1600': timeOfDayIcon('moon'),
  '2000': timeOfDayIcon('moon_with_stars'),
}
